import Cookies from 'js-cookie';
// import { notification } from 'antd';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';

const API_ENDPOINT = `${process.env.REACT_APP_API}/api/v1/iot`;
const { getLoad, getSuccess, getErr, getExcelLoad, getExcelSuccess, getExcelErr } = actions;

// const addNotificationSuccess = () => {
//   notification.success({
//     message: 'Your Record has been Submited',
//   });
// };

// const addNotificationError = (err) => {
//   notification.error({
//     message: err,
//   });
// };

const getDiagnosticData = (sQuery, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(getLoad());
      const query = await DataService.get(`/diag${sQuery}`);
      const token = Cookies.get('access_token');

      if (token) await dispatch(getSuccess(query.data.data));
      else await dispatch(getSuccess([]));
      callback();
    } catch (err) {
      await dispatch(getErr(err));
    }
  };
};

const exportToExcelData = (sQuery, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(getExcelLoad());
      const URL = `${API_ENDPOINT}/diag/xl${sQuery}`;

      window.open(URL);
      await dispatch(getExcelSuccess(true));
      callback();
    } catch (err) {
      await dispatch(getExcelErr(err));
    }
  };
};

// https://pgiotapi.versamicro.in/api/v1/iot/ams?date=2023-08-02&machineId=KHE-AMS-001

export { getDiagnosticData, exportToExcelData };
